import { InjectionToken } from '@angular/core';
import { TrumbowygOptions } from './trumbowyg-options';

export const TRUMBOWYG_OPTIONS = new InjectionToken<TrumbowygOptions>(
  'Trumbowyg options'
);
